import React from 'react'
import { CurrentNavHeader } from '../../components/current-nav-header/CurrentNavHeader'
import { RouteProps } from '../../routes/AppRouter'
import { Dashboard as D } from '../../features/dashboard'
import { useTranslation } from 'react-i18next'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremeLogoMain.svg'
import style from '../layout/Main.module.css'

export function Dashboard(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const { t } = useTranslation()

  return (
    <>
      <D id={props.id} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
